export default __webpack_public_path__ + "static/media/3067.a75a039f.jpg";